import React from 'react';
import { Tooltip } from '@roo/roo';
import './aboutAward.scss';
import blue_bg from '../../assets/images/blue_bg.png';
import gray_bg from '../../assets/images/gray_bg.png';
import white_bg from '../../assets/images/white_bg.png';
import img_hexagon from '../../assets/lottie/decontamination/img_hexagon.png';
import img_line from '../../assets/lottie/decontamination/img_line.png';

import DynamicCard from '../DynamicCard/DynamicCard';
export const s3Url = 'https://s3plus.sankuai.com/greentech/static_resource/images/';
// lottie动画
import captureCarbon from '../../assets/lottie/captureCarbon/data.json';
import lowCarbon from '../../assets/lottie/lowCarbon/data.json';
import energyStorage from '../../assets/lottie/energyStorage/data.json';
import material from '../../assets/lottie/material/material.json';
import environmentScience from '../../assets/lottie/environmentScience/data.json';
import chemical from '../../assets/lottie/chemical/data.json';
import energyScience from '../../assets/lottie/energyScience/data.json';
import chemicalIndustry from '../../assets/lottie/chemicalIndustry/data.json';
import fontCrossing from '../../assets/lottie/frontCrossing/data.json';
import { APPLY_YEAR } from '../../utils/config';
const AboutAward = () => {
  const focus = [
    {
      title: '绿色低碳材料',
      lottieData: { data: lowCarbon, assetPath: '' },
      tooltip: '主要包括生物基材料、循环再生材料、材料的绿色低碳制造等方向的科学研究和技术突破',
    },
    {
      title: '碳捕集及资源化利用',
      lottieData: { data: captureCarbon, assetPath: '' },
      tooltip: '主要包括碳捕集和分离、二氧化碳资源化利用等方向的科学研究和技术突破',
    },
    {
      title: '新能源及储能',
      lottieData: { data: energyStorage, assetPath: '' },
      tooltip: '主要包括光伏、生物质能、氢能等新能源方向，以及化学储能、电化学储能等储能方向的科学研究和技术突破',
    },
  ];
  const discipline = [
    {
      title: '材料科学',
      lottieData: {
        data: material,
        assetPath: s3Url,
      },
    },
    {
      title: '化学',
      lottieData: {
        data: chemical,
        assetPath: s3Url,
      },
    },
    {
      title: '化学工程',
      lottieData: {
        data: chemicalIndustry,
        assetPath: s3Url,
      },
    },
    {
      title: '环境科学技术',
      lottieData: { data: environmentScience, assetPath: '' },
    },
    {
      title: '能源科学技术',
      lottieData: {
        data: energyScience,
        assetPath: s3Url,
      },
    },
    {
      title: '前沿交叉',
      lottieData: {
        data: fontCrossing,
        assetPath: s3Url,
      },
    },
  ];
  const focusElement = focus.map((item) => {
    return (
      <div className="focus-item" key={item.title}>
        <div>
          <DynamicCard title={item.title} lottieData={item.lottieData}></DynamicCard>
        </div>
        <Tooltip content={item.tooltip}>
          <span>{item.title}</span>
        </Tooltip>
      </div>
    );
  });
  const disciplineElement = discipline.map((item, index) => {
    return (
      <div className="discipline-item" key={item.title}>
        <div className="discipline-de">
          <DynamicCard title={item.title} lottieData={item.lottieData} />
        </div>
        {/*<div className='discipline-subtitle'>*/}
        {/*  <span>学科领域</span>*/}
        {/*  <span>0{index}</span>*/}
        {/*</div>*/}
        <div className="discipline-title">
          <span>{item.title}</span>
        </div>
      </div>
    );
  });
  return (
    <div className="about-award-component">
      <div className="focus-point">
        <div className="time">
          <img src={blue_bg} alt="" />
          <div>
            <span style={{ lineHeight: '60px' }}>{APPLY_YEAR}</span>
            <span>重点关注议题</span>
          </div>
        </div>
        {focusElement}
        <div className="focus-item">
          <div>
            {/* <DynamicCard title={item.title} lottieData={item.lottieData}></DynamicCard> */}
            <div className="d-card">
              <div className="decontamination">
                <img className="decontamination-left" src={img_hexagon} alt="" />
                <img className="decontamination-right" src={img_hexagon} alt="" />
                <img className="line-top" src={img_line} alt="" />
                <img className="line-bottom" src={img_line} alt="" />
              </div>
            </div>
          </div>
          <Tooltip flip content="统筹温室气体减排与水、气、土、固废等领域污染治理协同控制，实现二者协同增效的科学研究和技术突破">
            <span>降碳减污协同控制</span>
          </Tooltip>
        </div>
      </div>
      <div className="discipline">{disciplineElement}</div>
      <div className="award-setting">
        <div className="left-content">
          <img src={white_bg} alt="" />
          <div>
            <span className={'title-t-sp'}>{APPLY_YEAR}</span>
            <span className="middle">青山科技奖</span>
            <span style={{ marginTop: 8 }}>奖项说明</span>
          </div>
        </div>
        <div className="right-content">
          <img src={gray_bg} alt="" />
          <div>
            <div className="quota">
              <span>奖励名额</span>
              <span className="middle title-t-sp">10</span>
              <span>中国内地及港澳地区工作的45周岁及以下青年科研工作者</span>
            </div>
            <div className="money">
              <span>奖金</span>
              <span className="middle title-t-sp">1,000,000</span>
              <span>人民币/人</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutAward;
